import { OnInit, OnDestroy, Component } from '@angular/core';
import { CanvasEvent } from 'src/app/events/canvas.event';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { Subscription } from 'rxjs';
import { LabelEvent } from 'src/app/events/label.event';

@Component({
	selector: 'app-base',
	template: ''
  })
export class BaseToolComponent implements OnInit, OnDestroy {

	protected _labelData: LabelData;
	protected _layerData: LayerData;

	protected _labelSubscription: Subscription;

  /**
	 * Constructor
	 */
  constructor() {

  }

	/**
	 * On init
	 */
  ngOnInit() {

	}

	/**
	 * Display label
	 */
	protected clearCurrentLabel(): void {
		if (this._labelSubscription) {
			this._labelSubscription.unsubscribe();
			this._labelSubscription = null;
		}
	}
	protected setLabel(): void {
		this._labelSubscription = this._labelData.onChange.subscribe({
			next: (event: LabelEvent) => {
				if (event.type == LabelEvent.CHANGE) {
					this.labelUpdated(event.data);
				} else if (event.type == LabelEvent.ADD_LAYER) {
					this.labelLayerAdded(event.data);
				} else if (event.type == LabelEvent.REMOVE_LAYER) {
					this.labelLayerRemoved(event.data);
				} else if (event.type == LabelEvent.REORDER_LAYERS) {
					this.labelLayersReordered();
				}
			}
		});
	}

	/**
	 * Set layer
	 */
	protected setLayer(): void {

	}

	/**
 	 *  Label updated
 	 */
	protected labelUpdated(data: LayerData):void {

	}

	/**
 	 *  Label updated
 	 */
	protected labelLayerAdded(data: LayerData): void {

	}

	/**
 	 *  Label updated
 	 */
	protected labelLayerRemoved(data: LayerData): void {

	}

	/**
 	 *  Label updated
 	 */
	protected labelLayersReordered(): void {

	}

	/**
   * On command
   */
	protected processCommand(event:CanvasEvent): void {
		switch(event.type) {
			case CanvasEvent.FIT_CANVAS:
				this.fitCanvas();
				this.centerCanvas();
			break;
			case CanvasEvent.SET_SELECT_MODE:
				this.selectMode();
				break;
			case CanvasEvent.SET_PAN_MODE:
				this.panMode();
				break;
			case CanvasEvent.SET_ZOOM_IN_MODE:
				this.zoomInMode();
				break;
			case CanvasEvent.SET_ZOOM_OUT_MODE:
				this.zoomOutMode();
				break;
			case CanvasEvent.ROTATE_CANVAS:
				this.rotateCanvas();
				break;
			case CanvasEvent.CENTER_LAYER_HORIZONTALLY:
				this.centerLayerHorizontally();
				break;
			case CanvasEvent.CENTER_LAYER_VERTICALLY:
				this.centerLayerVertically();
				break;
			case CanvasEvent.SET_CROP_MODE:
				this.cropMode();
				break;
		}
	}

	/**
	 * Fit canvas
	 */
	protected fitCanvas(): void {

	}

	/**
	 * Center canvas
	 */
	protected centerCanvas(): void {

	}

	/**
	 * Select mode
	 */
	protected selectMode(): void {

	}

	/**
	 * pan mode
	 */
	protected panMode(): void {

	}

	/**
	 * Zoom in mode
	 */
	protected zoomInMode(): void {

	}

	/**
	 * Zoom out mode
	 */
	protected zoomOutMode(): void {

	}

	/**
	 * Rotate canvas
	 */
	protected rotateCanvas(): void {

	}

	/**
	 * Center layer horizontally
	 */
	protected centerLayerHorizontally(): void {

	}

	/**
	 * Center layer vertically
	 */
	protected centerLayerVertically(): void {

	}

	/**
	 * Crop
	 */
	protected cropMode(): void {

	}

	/**
	 * Layer data
	 */
	get layerData():LayerData {
		return this._layerData;
	}

	/**
	 * Labek data
	 */
	get labelData(): LabelData {
		return this._labelData;
	}

	/**
	* On destroy
	*/
  ngOnDestroy() {
		if (this._labelSubscription) {
			this._labelSubscription.unsubscribe();
			this._labelSubscription = null;
		}
  }
}
